import { BlocksIconWarningTriangleFilled } from 'blocks-nextjs/blocks-web-components/components/icon/icons/warning-triangle-filled';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconWarningTriangleFilled = createComponent({
  react: React,
  tagName: 'cat-icon-warning-triangle-filled',
  elementClass: BlocksIconWarningTriangleFilled
});
